<template>
	<div>
		<form action="https://new.colorwayrb.com/backend/mreportexe.php" method="POST" class="repGenForm">
			<div class="repGenForm__inputs-wrap">
				<div class="input-group">
					<label for="date_from" class="input-group__label">From:</label>
					<input type="date" id="date_from" name="date_from" class="input-group__input" />
				</div>

				<div class="input-group">
					<label for="date_to" class="input-group__label">To:</label>
					<input type="date" id="date_to" name="date_to" class="input-group__input" />
				</div>

				<div class="input-group">
					<label for="" class="input-group__label">Products:</label>

					<multiselect v-model="value" label="name" track-by="value" :options="options" :multiple="true" :close-on-select="false" :clear-on-select="false" name="product[]"></multiselect>
				</div>

				<div class="input-group">
					<label for="" class="input-group__label">Customer:</label>
					<select name="provider" id="provider" class="input-group__select">
						<option v-for="customer in customerList" v-bind:key="customer.id" v-bind:value="customer.value">{{ customer.text }}</option>
					</select>
					
				</div>
				
				<div class="input-group">
					<label for="" class="input-group__label">Shippers:</label>
					<select name="shipby" class="input-group__select">
						<option value="ALL">All</option>
						<option value="STANDARD">Standard</option>
						<option value="EXPRESS">Express</option>
					</select>
				</div>
			</div>
			<div class="repGenForm__inputs-wrap">
				<div class="input-group">
					Style: <input type="radio" name="style" value="normal">Normal  <input type="radio" name="style" value="gooten">Gooten  <input type="radio" name="style" value="printify">Printify  <input type="radio" name="style" value="redbubble">Redbubble  <input type="radio" name="style" value="new">Experimental
				</div>
				
				<div class="input-group">
					Timezone: <input type="radio" name="tz" value="GB">GB  <input type="radio" name="tz" value="US">US  <input type="radio" name="tz" value="AU">AU 
				</div>
				
			</div>
			
			
			
			<input type="hidden" name="productlist" v-bind:value="JSON.stringify(value) " >
			
			<input
				class="btn btn--blue3 repGenForm__submit"
				type="submit"
				value="Download"
				
			/>
		</form>
	</div>
</template>

<script>
import Vue from "vue";
//import CustomDropDown from "../global/CustomDropDown.vue";

import Multiselect from 'vue-multiselect'

// register globally
Vue.component('multiselect', Multiselect)
  
import axios from "axios";

export default Vue.extend({
	name: "",
	components: {
		//CustomDropDown
	},
	data () {
      return {
        value: null,
        options: [],
		customerList: {},
		productList: {},
      }
    },
	mounted() {
		{
			
			this.getTaskList();
			this.getProductList();
			
			this.sessionid = this.$store.getters.sessionid;
			
			
		}
	},
	methods: {
		getTaskList() {
			axios.get('https://new.colorwayrb.com/backend/customerlist.php').then(response => {
				this.customerList = response.data;
				console.log(response.data);
				
			});
		},
		
		getProductList() {
			axios.get('https://new.colorwayrb.com/backend/productlist.php').then(response => {
				this.productList = response.data;
				console.log(response.data);
				
				for (var i=0;i<response.data.length;i++) {
				
				
					this.options = this.options.concat({value: response.data[i].value, name: response.data[i].text});
				
				}
				console.log(this.options);
				
				
			});
		},
	}
});
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.repGenForm {
	padding: 20px 0;
	&__inputs-wrap {
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 0 30px;
		margin: 0 auto;
	}

	&__submit {
		border-radius: 5px;
		padding: 5px 20px;
		margin: 0 auto;
		display: block;
	}
}

.input-group {
	margin: 0 15px;

	&__label {
		font-weight: 500;
		padding: 5px 0;
		display: block;
		width: 120px;
	}

	&__input,
	&__select {
		border: $border-color 1px solid;
		display: inline-block;
		width: 150px;
		height: 40px;
		padding: 5px;
	}

	&__input {
		padding: 0 0 0 10px;
	}
}
</style>